export const iconFontAwesomeEmojiFaceGrinTears = (
	<i className="fa-solid fa-face-grin-tears"></i>
);
